import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, {Component} from 'react';
import axios from "axios";
import { useEffect, useState , useRef } from 'react';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import NumberFormat from 'react-number-format';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneInput from 'react-phone-number-input';
import CheckIcon from "@mui/icons-material/Check";
import "./style.css";
import {useNavigate } from "react-router-dom";
import { useLocation} from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default function NewInquiry(){
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [names,setNames] = useState(["Instagram/Facebook Ads", "Google Ads (LiveChat)", "Google Ads (WhatsApp)", "Partner", "Kenalan", "Ga Tau"]);
    const [produk,setProduk] = useState(["Virtual Office", "Private Office", "Meeting Room Kecil", "Meeting Room Besar (Event Room)", "Pendirian PT", "Pendirian CV", "Izin Khusus", "PKP", "Pajak", "Akutansi", "Website", "Merek"]);
    const [lokasi,setLokasi] = useState(["Jakarta Selatan", "Jakarta Barat", "Jakarta Pusat", "Jakarta Utara", "Jakarta Timur", "Tangerang", "Bekasi", "Bali", "Surabaya", "Depok", "Kalimantan"]);
    const [sales, setSales]= useState(["Adnan", "Diva", "Felly", "Reinner"])
    const [isEnd,setIsEnd] = useState("loading..")
    const [searchThis, setsearchThis]= useState("Phone");
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const passed = useLocation();
    const [contractData, setContractData] = useState(passed.state.post);  // Added this line
    const [showData, setShowData] = useState(passed.state.post);  // Added this line
    const [uploadedNPWPStat, setUploadedNPWPStat] = useState(false);
    const [uploadedKTPStat, setUploadedKTPStat] = useState(false);
    const [fileNPWP, setNPWPFile] = useState(null);
    const [fileKTP, setKTPFile] = useState(null);
    const [npwpfileName, setNPWPFileName] = useState("");
    const [ktpfileName, setKTPFileName] = useState("");

    const press = () => {
        console.log(passed)
    }
    //FollowUp History
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const fileInputNPWP = useRef(null);

    const handleNPWPUploadButtonClick = () => {
        fileInputNPWP.current.click();
      };
      const clearnpwpFile = (event)=>{
        setNPWPFile(null);
        setNPWPFileName("");
        setUploadedNPWPStat(false);
      }
      const clearktpFile = (event)=>{
        setKTPFile(null);
        setKTPFileName("");
        setUploadedKTPStat(false);
      }
      const handleKTPUploadButtonClick = () => {
        fileInput.current.click();
      };
      const clearKTPFile = (event)=>{
        setKTPFile(null);
        setKTPFileName("");
        setUploadedKTPStat(false);
      }
    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const handleNPWPFileChange = (event) => {
        setNPWPFile(event.target.files[0]);
        setNPWPFileName(event.target.files[0].name);
        setUploadedNPWPStat(true);
      };
      const handleKTPFileChange = (event) => {
        setKTPFile(event.target.files[0]);
        setKTPFileName(event.target.files[0].name);
        setUploadedKTPStat(true);
      };

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);
    const fetchPosts = async () => {
        // Extract the company IDs from the passed post
        const originalCompanies = passed.state.post.Companies;
        const companyIds = originalCompanies.map(company => company.CompanyID).join(',');
        
        // Fetch the companies
        const response = await axios.get(`/MultipleCompanyProfile?companyIds=${companyIds}`);
        const fetchedCompanies = response.data.data;
        
        // Merge original Companies data with fetched Companies data
        const mergedCompanies = originalCompanies.map((company, i) => {
            return {
                ...company,
                fetchedData: fetchedCompanies[i]  // assuming the fetchedCompanies maintains the same order as originalCompanies
            };
        });
        
        // Add the merged companies to the post
        let newPost = { ...passed.state.post, Companies: mergedCompanies };
        
        // Update the posts state
        setPosts([...posts, newPost]);
    }
    
    
    const DownloadDoc = (event) => {
        let post;
        if(event === "NPWP"){
             post = showData.npwpKey
        }
        if(event === "KTP"){
             post = showData.ktpKey
        }
        console.log("here")
        if(post){
            console.log("here22")

            if (Array.isArray(post)) {
                post.forEach(filename => {
                console.log(filename)
                  axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                      responseType: 'blob' // Tell axios to get the response as a blob
                  })
                  .then((response) => {
                    const contentType = response.headers['content-type'];
                    console.log(response);
                    console.log(response.headers)
                    console.log(contentType)
                    if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                      // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                      const blob = new Blob([response.data], { type: contentType });
                      const url = URL.createObjectURL(blob);
                      window.open(url);
                  } else {
                      // For other file types, download the file
                      const link = document.createElement('a');
                      link.href = window.URL.createObjectURL(new Blob([response.data]));
                      link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                      document.body.appendChild(link);
                      link.click();
                  }
                  })
                  .catch((error) => {
                      console.log('Error fetching the file:', error);
                  });
              });
          } else {
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${post}`, {
              responseType: 'blob' // Tell axios to get the response as a blob
          })
          .then((response) => {
            const contentType = response.headers['content-type'];
            console.log(response);
            console.log(response.headers)
            console.log(contentType)
            if (['image/png', 'image/jpeg', 'image/gif','image/webp', 'image/jpg' , 'application/pdf'].includes(contentType)) {
              // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
              const blob = new Blob([response.data], { type: contentType });
              const url = URL.createObjectURL(blob);
              window.open(url);
          } else {
              // For other file types, download the file
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(new Blob([response.data]));
              link.setAttribute('download', 'file'); // Modify the filename and extension as needed
              document.body.appendChild(link);
              link.click();
          }
          })
          .catch((error) => {
              console.log('Error fetching the file:', error);
          });
          }
          }
    }
    ///end download
    const fileInput = useRef(null);


    //Edit Inquiry Start
    const [isEditable, setIsEditable] = useState({});
    const [error,setError] = useState();
    const handleNPWP = (event) => {
        let value = event.target.value;
  value = value.replace(/\D/g, ""); // Remove any non digit character
  value = value.replace(/^(\d{2})(\d)/, "$1.$2");
  value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
  value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})-(\d{1})(\d)/, "$1.$2.$3-$4.$5");
  value = value.slice(0,20); // Limit length to 15 digits and 5 special characters (20 in total)
        setContractData({...contractData, NPWP: value});  // Changed this line  
      };
      const handleKTP = (event) => {
        let value = event.target.value;
        setContractData({...contractData, KTP: value});  // Changed this line  
      };
      
    const handleEditClick = (field) => {
        setContractData(showData)
      setError("")
      setIsEditable(prevState => {
        const newState = { ...prevState }; // copy all fields
        for (let key in newState) {
          if (key !== field) newState[key] = false; // if it's not the field we're toggling, set it to false
        }
        newState[field] = !prevState[field]; // toggle the field we're interested in
        return newState;
      });
    }

    const setPhoneNumber = (event) => {
        console.log(event)
        setContractData({...contractData, Phone: event});  // Changed this line  
    }
    const setNamaKlien = (event) => {
        setContractData({...contractData, Nama: event.target.value});  // Changed this line  
    }

    const setEmail = (event) => {
        setContractData({...contractData, Email: event.target.value});  // Changed this line  
    }

    
    const setAlamat = (event) => {
        setContractData({...contractData, Alamat: event.target.value});  // Changed this line  
    }

    const setIklan = (event) => {
        setContractData({...contractData, Iklan: event});  // Changed this line  
    }
    const setBDate = (event) => {
        setContractData({...contractData, bDate: event});  // Changed this line  
    }

    const setSelectedProduk = (event) => {
        setContractData({...contractData, ProdukInterest: event});  // Changed this line  
    }

    const setSelectedLokasi = (event) => {
        setContractData({...contractData, LokasiInterest: event});  // Changed this line  
    }

    const setSelectedSales = (event) => {
        setContractData({...contractData, Sales: event});  // Changed this line  
    }

    const setNomorTelp = (event) => {
        setContractData(prevState => ({
            ...prevState,
            Phone: [event, ...prevState.Phone.slice(1)]
          }));
    }
    const [countryCode, setCountryCode] = useState('ID'); // default to ID
    useEffect(() => {
        if (typeof contractData.Phone === 'string') {
          const phoneNumber = parsePhoneNumberFromString(contractData.Phone);
          if (phoneNumber) {
            setCountryCode(phoneNumber.country);
            setNomorTelp(phoneNumber.nationalNumber);
          }
        }
      }, [contractData.Phone]);
    const UpdateKlien = () => {
        if(contractData.Nama && contractData.bDate){
            
            // Assuming that fileKTP and fileNPWP are your file objects
           const filesToUpload = [
           { file: fileNPWP, name: 'fileKTP' },
           { file: fileKTP, name: 'fileNPWP' },
         ];
 
         // Map over the files array and return an array of promises
         const uploadPromises = filesToUpload.map((fileObj) => {
           if (fileObj.file) { // if the file is not null, upload it
             return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`, {
               params: {
                 filename: fileObj.name // send the filename to the server
               }
             })
             .then(response => {
               const uploadUrl = response.data.url;
               const key = response.data.key; // Get the key from the response
 
               return fetch(uploadUrl, {
                 method: 'PUT',
                 headers: {
                   'Content-Type': fileObj.file.type
                 },
                 body: fileObj.file
               }).then(() => key); // After the file is uploaded, return the key
             })
             .catch(error => {
               console.error('Error during file upload:', error);
             });
           }
 
           // if the file is null, return a resolved promise with value null
           return Promise.resolve(null);
         });
           
           
         Promise.all(uploadPromises)
         .then(fileKeys => {
           const [npwpKey, ktpKey] = fileKeys; // Extract keys from the resolved values array
           if(fileNPWP !== null){
                console.log("ini npwp key:" + npwpKey)
               setContractData({...contractData, npwpKey: npwpKey});  // Changed this line  
           }
           console.log("ini contractData")
           console.log(contractData)
           axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateKlien`, {
               contractData, npwpKey, ktpKey
           }).then(response => {
               handleEditClick('editInquiry')
               setShowData(contractData)
       }).catch(error => {
           setError(`Error: ${error.response.data.message}`);  // Here you can set the error message you need
       })})

       }else{
           setError("Ada data yang belum kamu isi")
       }
    }

    //Edit Inquiry End
    return <Grid container>
    <Grid item xl={0.5} lg={0.5} md={0.5} sm={3.2} className="leftmenucolor">
        <LeftMenu/>
    </Grid>
    <Grid item xl={11.5} lg={11.5} md={11.5} sm={8.8}>
        <Grid className="boxshadowclass">
            <Header></Header>
        </Grid>
        <Grid sx={{p:5}}>
            <Grid container>
                <Grid container direction="column" justifyContent="center" alignItems="center" xs={3}>
                    <Grid item>
                        <Avatar sx={{ width: 200, height: 200 }}></Avatar>
                    </Grid>
                </Grid>


                <Grid xs={9}>
                    <Grid container sx={{p:1}}>
                        <Grid sx={{mr:1}}><b>
                            Nama:
                            </b> 
                        </Grid>
                        <Grid>
                        {isEditable.editInquiry ? <TextField  label="Nama Klien" placeholder="Nama Klien" value={contractData.Nama} onChange={(event)=>setNamaKlien(event)}></TextField>
                        : showData.Nama? (showData.Nama):(<Typography variant="body1" style={{ color: 'grey', fontStyle: 'italic' }}>Tidak ada nama</Typography>)}
                        </Grid>
                    </Grid>
                    <Grid container sx={{p:1}}>
                        <Grid sx={{mr:1}}><b>
                            Nomor Telepon:
                            </b> 
                        </Grid>
                        <Grid>
                        {isEditable.editInquiry ? 
                            <PhoneInput
                                international
                                defaultCountry={countryCode}
                                value={contractData.Phone[0]} 
                                placeholder="Nomor Telepon"
                                onChange={(event) => setNomorTelp(event)}
                            />
                            : 
                            showData.Phone ? 
                                (showData.Phone) : 
                                (<Typography variant="body1" style={{ color: 'grey', fontStyle: 'italic' }}>
                                Tidak ada Nomor Telepon
                                </Typography>)
                            }
                        </Grid>
                    </Grid>
                    <Grid container sx={{p:1}}>
                        <Grid sx={{mr:1}}><b>
                            Email:
                            </b> 
                        </Grid>
                        <Grid>
                            {isEditable.editInquiry ? <TextField value={contractData.Email} label="Email Klien" placeholder="Email Klien" onChange={(event)=>setEmail(event)}></TextField>
                            :showData.Email? (showData.Email):(<Typography variant="body1" style={{ color: 'grey', fontStyle: 'italic' }}>Tidak ada email</Typography>)}                        
                        </Grid>
                    </Grid>
                    <Grid container sx={{p:1}}>
                        <Grid sx={{mr:1}}><b>
                            Tanggal Lahir:
                            </b> 
                        </Grid>
                        <Grid>
                            {isEditable.editInquiry ? 
                                <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={contractData.bDate}
                                    onChange={(event)=>setBDate(event)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                                </LocalizationProvider>
                            :showData.bDate? (showData.bDate):(<Typography variant="body1" style={{ color: 'grey', fontStyle: 'italic' }}>Tidak ada Data</Typography>)}                        
                        </Grid>
                    </Grid>
                    <Grid container sx={{p:1}}>
                        <Grid sx={{mr:1}}><b>
                            Alamat KTP
                            </b> 
                        </Grid>
                        <Grid>
                            {isEditable.editInquiry ? <TextField value={contractData.Alamat} label="Alamat Klien" placeholder="Alamat Klien" onChange={(event)=>setAlamat(event)}></TextField>
                            :showData.Alamat? (showData.Alamat):(<Typography variant="body1" style={{ color: 'grey', fontStyle: 'italic' }}>Tidak ada Alamat</Typography>)}                        
                        </Grid>
                    </Grid>
                
            <Grid container  sx={{p:1}}>
                        <Grid sx={{mr:1}}><b>
                        NPWP:
                            </b> 
                        </Grid> {isEditable.editInquiry ? <Grid container>
                        
                        <Grid sx={{mr:2}}>
                            <TextField onChange={(event)=>handleNPWP(event)} value={contractData.NPWP}></TextField>
                        </Grid>
                        <Grid>
                            
                        </Grid>
                            <input
                                type="file"
                                ref={fileInputNPWP}
                                onChange={handleNPWPFileChange}
                                style={{ display: 'none' }}
                            />
                            <Button
                                color={uploadedNPWPStat ? "success" : "primary"}
                                variant="contained"
                                onClick={handleNPWPUploadButtonClick}
                                style={{ marginRight: '8px' }}
                            >
                                Upload NPWP Baru
                            </Button>
                            <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {npwpfileName.length > 20 ? `${npwpfileName.slice(0, 17)}...` : npwpfileName}
                            </Typography>
                            {uploadedNPWPStat && (
                                <IconButton size="small" onClick={clearnpwpFile}>
                                <CloseIcon />
                                </IconButton>
                            )}
                            </Grid>
                        : showData.NPWP? (<>{showData.NPWP} <Button onClick={()=>DownloadDoc("NPWP")}>Download NPWP</Button></>) : (<span style={{ color: 'grey', fontStyle: 'italic' }}>Belum ada data</span>)}
                    </Grid>

                    <Grid container  sx={{p:1}}>
                        <b>KTP/Passport:</b> {isEditable.editInquiry ? <Grid container>
                        
                        <Grid sx={{mr:2}}>
                            <TextField onChange={(event)=>handleKTP(event)} value={contractData.KTP}></TextField>
                        </Grid>
                        <Grid>
                            
                        </Grid>
                            <input
                                type="file"
                                ref={fileInput}
                                onChange={handleKTPFileChange}
                                style={{ display: 'none' }}
                            />
                            <Button
                                color={uploadedKTPStat ? "success" : "primary"}
                                variant="contained"
                                onClick={handleKTPUploadButtonClick}
                                style={{ marginRight: '8px' }}
                            >
                                Upload KTP Baru
                            </Button>
                            <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {ktpfileName.length > 20 ? `${ktpfileName.slice(0, 17)}...` : ktpfileName}
                            </Typography>
                            {uploadedKTPStat && (
                                <IconButton size="small" onClick={clearktpFile}>
                                <CloseIcon />
                                </IconButton>
                            )}
                            </Grid>
                        : showData.KTP? (<>{showData.KTP} <Button onClick={()=>DownloadDoc("KTP")}>Download KTP</Button></>) : (<span style={{ color: 'grey', fontStyle: 'italic' }}>Belum ada data</span>)}
                    </Grid>
                    </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{mt:5}}>
                        {isEditable.editInquiry ? <Grid container justifyContent="flex-end">
                            <Button sx={{m:1}} variant="contained" color="error" onClick={() => handleEditClick('editInquiry')}>Batal</Button>
                            <Button sx={{m:1}} variant="contained" color="success" onClick={()=>UpdateKlien()}>Simpan</Button>
                        </Grid>
                        :<IconButton onClick={() => handleEditClick('editInquiry')}><EditIcon sx={{ fontSize: 24 }} color="primary"/></IconButton>}
            </Grid>
            <Button onClick={event=>console.log(posts)}>Klik</Button>
            {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}

            <Divider variant="inset" sx={{ mb:5, height:2, bgcolor: 'black'}} />
            
            <Grid container sx={{mt:5}} direction="column" justifyContent="center" alignItems="center">
                            <Grid container xs={9.6} sx={{mt:5,mb:5}} direction="column" justifyContent="center" alignItems="center">
                                <Typography align="center"><b>List Company</b></Typography>
                            </Grid>
                            
                            <Paper sx={{ width: '80%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 300, minHeight: 240 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Nama Perusahaan
                                                </TableCell>
                                                <TableCell>
                                                    Posisi
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post,) => (
                                        <TableBody key={post._id}> {/* Add key for each TableRow */}
                                            {post.Companies.map((company) => (
                                            <TableRow hover key={company._id}> {/* Add key for each TableCell */}
                                                <TableCell style={{cursor:'pointer'}}>
                                                    <p>{company.fetchedData?.namaPerusahaan}</p> {/* Add Fetched Company Name Here */}
                                                </TableCell>
                                                <TableCell>                                                    
                                                    <p>{company.posisi}</p> {/* Add Company Position Here */}
                                                </TableCell>
                                            </TableRow>
                                            ))}
                                        </TableBody>
                                    ))}

                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
            </Grid>
        </Grid>
        

    </Grid>
</Grid>
}